require('./loanView.scss');

const PropTypes = require('prop-types');

// @ vendor
const React = require('react');
const { connect } = require('react-redux');
const PureRenderMixin = require('react-addons-pure-render-mixin');
const { withRouter } = require("react-router-dom");
// @ helpers
const { formatText, FormattedText } = require('core/i18n').i18n;
const { toCamelCase } = require('utilities/stringHelper');
const MortgagesCollectiveTagTooltip = require('components/mortgagesCollectiveTagTooltip/mortgagesCollectiveTagTooltip');
// @ commons
const { CommercialAdsCCValidated: CommercialAds } = require('components/commons/commercialAds/commercialAds');
const { LoadingSection } = require('commonsComponents/loadingSection');
const { EmptyState } = require('commonsComponents/emptyState');
const { OKButton } = require('components/commons/OKButton/OKButton');
const { OKSectionBox } = require('commonsComponents/OKSectionBox');
// @ actions
const collectiveActions = require('actions/collectives');
const { requestPublicInformation } = require('actions/myGlobalPosition');
const { requestLoanInterveners } = require('../../actions/loansInterveners');
const { requestLoanGeneralData } = require('../../actions/loansGeneralData');
const loansAliasActions = require('../../actions/postLoanAlias');
const mortgageRequestTaxesInformationActions = require('actions/mortgageRequest/mortgageRequestTaxesInformation');
const partialAmortizationAction = require('../../actions/loanPartialAmortization');
const { getMortgageAssociatedInsurances } = require('../../actions/mortgageAssociatedInsurances');
// @ components
const LoanInformation = require('../../components/loansAndMortgages/loans/loanInformation/loanInformation');
const LoansError = require('../../components/loansAndMortgages/loans/loansError/loansError');

const LoanHeader = require('../../components/loansAndMortgages/loans/loanHeader/loanHeader');
const LoanInsuranceBonificationsDetails = require('../../components/loansAndMortgages/loans/loanInsuranceDetail/loanInsuranceBonificationDetails');
// @ constants
const { MULTICHANNEL_UI_COMPONENT, MORTGAGE_TAXES_GROUP_CODE } = require('constants/index');
const { MORTGAGE_PRODUCT_NUMBER, getMortgageTypeProductSubType } = require('constants/mortgageRequestType');
const { MORTGAGE_CONTRACTED_INSURANCE } = require('constants/flagBasedFeatures');
const {
    PENDING_LOAN_ERROR,
    YEAR_MONTHS
} = require('../../loansConstants/index');
//@utilities
const { trackViewAndComercialSpace } = require('utilities/taggingViewHelper');
const {
    commonAnalyticsId,
    commonCatalogue,
} = require('utilities/taggingCommonCatalogue');
const { recordLinkV2 } = require('utilities/tagging');
//@analytics
const { catalogue, analyticsId } = require('../../components/loansAndMortgages/analytics/loansAndMortgagesAnalytics');

class LoanView extends React.Component {
    constructor(props) {
        super(props);

        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
        this.getLoanInformation = this.getLoanInformation.bind(this);
        this.onPostAlias = this.onPostAlias.bind(this);
    }

    componentDidMount() {
        const { match: { params: { loanId } }, immLoans, getMortgageAssociatedInsurances } = this.props;
        const immLoan = immLoans.getIn(['byId', loanId], false);

        if (!immLoan) {
            this.props.history.push('/myprofile/loans-mortgages');
        } else {
            trackViewAndComercialSpace({
                immLoan,
                analyticView: catalogue[analyticsId.PAGE_VIEW_INFORMATION],
                productImpressionList: 'loanDetail'
            });
        }
        immLoan.get('isMortgage') && getMortgageAssociatedInsurances(immLoan);
        this.getLoanInformation();
    }

    componentWillReceiveProps(nextProps) {
        const { match: { params: { loanId } }, immProfile, immTaxesInformation, taxesInformationRequest, immLoans } = this.props;
        const immLoan = immLoans.getIn(['byId', loanId], false);
        const productType = getMortgageTypeProductSubType(immLoan.get('productSubType'));
        const term = !!nextProps.immPartialAmortization ? nextProps.immPartialAmortization.getIn(['loanPartialAmortization', 'datosGrles', 'plazoLiquidacion'], 0) : 0;
        const productNumber = MORTGAGE_PRODUCT_NUMBER[productType];
        const taxesHasBeenFetched = immTaxesInformation.get('taxesHasBeenFetched');
        const taxesIsFetching = immTaxesInformation.get('isFetching');

        if (!taxesHasBeenFetched && !taxesIsFetching && !!productNumber && term !== 0) {
            const collectiveType = immProfile.get('collectiveType');
            const code3 = collectiveType.get('code3');
            const code4 = collectiveType.get('code4');
            const mortgageInfo = {
                type: productNumber,
                duration: term / YEAR_MONTHS,
                code3: code3,
                code4: code4,
                groupCode: MORTGAGE_TAXES_GROUP_CODE
            };
            taxesInformationRequest(mortgageInfo);
        }
    }

    onPostAlias(value) {
        const { match: { params: { loanId } }, postAlias, immLoans } = this.props;
        const immLoan = immLoans.getIn(['byId', loanId], false);
        if (immLoan) {
            postAlias(loanId, value, immLoan.get('isMortgage'));
        }
    }

    getLoanInformation() {
        const { match: { params: { loanId } }, requestLoanGeneralData, requestLoanInterveners, immLoans,
            requestPlanAmortization, requestPartialAmortization, immAccounts, getCollectiveInfo } = this.props;
        const immLoan = immLoans.getIn(['byId', loanId], false);

        if (immLoan) {
            const productType = {
                type: immLoan.get('product'),
                subType: immLoan.get('productSubType'),
                standard: immLoan.get('productStandard')
            };

            requestLoanGeneralData(loanId);
            requestLoanInterveners(loanId);
            requestPlanAmortization(immLoan);
            requestPartialAmortization(immLoan, immAccounts)
            getCollectiveInfo([productType], MULTICHANNEL_UI_COMPONENT);
        }
    }

    buildBreadcrum(immLoan) {
        return [
            {
                text: formatText('breadcrumb-loansAndMortgages'),
                url: `/myprofile/loans-mortgages`
            },
            {
                text: immLoan.get('alias'),
            }
        ];
    }

    buildError(errorMsg, showRetryButton) {
        let retryButton;

        if (showRetryButton) {
            const handleLoanInformation = () => {
                recordLinkV2(commonCatalogue[commonAnalyticsId.RETRY_BUTTON]());
                this.getLoanInformation();
            };

            retryButton = (
                <OKButton
                    onClick={handleLoanInformation}
                >
                    <FormattedText value="loan-retry" />
                </OKButton>
            );
        }

        return (
            <OKSectionBox>
                <EmptyState
                    primaryText={formatText(errorMsg)}
                    button={retryButton}
                    iconType="nointernet-banking" />
            </OKSectionBox>
        );
    }

    buildLoanInformation(toolTipContent) {
        const { match: { params: { loanId } }, immLoans, immAccounts } = this.props;
        const immLoan = immLoans.getIn(['byId', loanId], false);
        const accId = immAccounts.get('byOrder').find(accountId => {
            const trimCodbban = immAccounts.getIn(['byId', accountId, 'ibanComplex', 'codbban'], '').trim();
            return trimCodbban === immLoan.get('account').trim();
        });
        const accountAlias = accId ? immAccounts.getIn(['byId', accId, 'alias']) : '';

        return (
            <LoanInformation
                immLoan={immLoan}
                accountAlias={accountAlias}
                toolTipContent={toolTipContent}
            />
        )
    }

    buildInsuranceDetail(immMortgage) {
        const {
            immFlagBasedFeatures,
            immMortgageAssociatedInsurances,
            immLoans,
            match: { params: { loanId } },
        } = this.props;

        const contractNumber = immMortgage.get('newContractNumber');
        const mortgageAssociatedInsurances = immMortgageAssociatedInsurances.get('mortgageAssociatedInsurances');
        const mortgageContractedInsurance = immFlagBasedFeatures.get(MORTGAGE_CONTRACTED_INSURANCE);
        const isMortgage = immMortgage.get('isMortgage')
        const productSubType = immLoans.getIn(['byId', loanId, 'productSubType'], false);
        let insurance = null;

        if (mortgageAssociatedInsurances && contractNumber) {
            const currentInsurance = mortgageAssociatedInsurances.find(mortgageAssociatedInsurance =>
                mortgageAssociatedInsurance.get('mortgageContractNumber') === contractNumber)

            insurance = currentInsurance ? {
                link: '/myprofile/insurances/home/' + currentInsurance.get('policyCode'),
                title: formatText('insuranceLanding-homeInsurance')
            } : null;
        }

        return insurance || (isMortgage && !!mortgageContractedInsurance)
            ? <LoanInsuranceBonificationsDetails insurance={insurance} productSubType={productSubType} />
            : null;
    }

    isNotCombined() {
        const { match: { params: { loanId } }, immLoans } = this.props;
        const productSubType = immLoans.getIn(['byId', loanId, 'productSubType'], false)
        return !(productSubType === '801' || productSubType === '802' || productSubType === '803');
    }

    render() {
        const { immLoans, match, immTaxesInformation, immPartialAmortization } = this.props;
        const { params: { loanId } } = match;
        const immLoan = immLoans.getIn(['byId', loanId], false);
        let informationComponent;
        if (immLoan) {
            const immGeneralData = immLoan.get('generalData');
            const immInterveners = immLoan.get('interveners');
            const errorGeneralData = immGeneralData.get('error');
            const breadcrumb = this.buildBreadcrum(immLoan);
            const titleEditable = immLoan.get('isAliasUpdating') ? toCamelCase(immLoan.get('aliasTentative')) : toCamelCase(immLoan.get('alias'));
            const finalTitle = __CONTACT_CENTER__ ? titleEditable : null;
            const insuranceDetail = (immLoan.get('isMortgage') && this.isNotCombined())
                ? this.buildInsuranceDetail(immLoan)
                : null;

            if (immGeneralData.get('isFetching') || immInterveners.get('isFetching')) {
                informationComponent = <LoadingSection />;
            } else if (errorGeneralData || immInterveners.get('error')) {
                if (errorGeneralData.getIn(['description', 'message'])) {
                    informationComponent = this.buildError('loan-loansErrorMessage', true);
                } else if (errorGeneralData.get('description').toUpperCase() === PENDING_LOAN_ERROR) {
                    informationComponent = this.buildError('loan-pendingMessageError', false);
                } else {
                    informationComponent = this.buildError('loan-loansErrorMessage', true);
                }

            } else {

                const taxesHasBeenFetched = immTaxesInformation.get('taxesHasBeenFetched');
                let toolTipContent = '';

                if (taxesHasBeenFetched) {
                    const taxes = immTaxesInformation.get('taxes').toJS();
                    const productType = getMortgageTypeProductSubType(immLoan.get('productSubType'));
                    const monthlyFee = immPartialAmortization.get('receiptTotal');

                    toolTipContent = (
                        <MortgagesCollectiveTagTooltip
                            taxes={taxes}
                            mortgageType={productType}
                            monthlyFee={monthlyFee}
                        />
                    );
                }

                informationComponent = this.buildLoanInformation(toolTipContent);
            }

            return (
                <article className="loan-view">
                    <LoanHeader
                        immLoan={immLoan}
                        breadcrumbConfig={breadcrumb}
                        titleIsEditable={!__CONTACT_CENTER__}
                        titleEditable={titleEditable}
                        finalTitle={finalTitle}
                        handlePostAlias={this.onPostAlias}
                    />
                    <section className="loan-view__body">
                        <div className="row no-outside-gutter">
                            <div className="col-xs-9">
                                {informationComponent}
                                {insuranceDetail}
                            </div>
                            <div className="col-xs-3">
                                <CommercialAds path={match.path} type="banner-b" />
                            </div>
                        </div>
                    </section>
                </article>
            );
        }

        return null;
    }
}

LoanView.propTypes = {
    getCollectiveInfo: PropTypes.func.isRequired,
    immLoans: PropTypes.object.isRequired,
    immProfile: PropTypes.object,
    immAccounts: PropTypes.object.isRequired,
    immFlagBasedFeatures: PropTypes.object.isRequired,
    immMortgageAssociatedInsurances: PropTypes.object,
    requestPublicInformation: PropTypes.func.isRequired,
    match: PropTypes.object.isRequired,
    requestLoanGeneralData: PropTypes.func.isRequired,
    requestLoanInterveners: PropTypes.func.isRequired,
    getMortgageAssociatedInsurances: PropTypes.func.isRequired,
    postAlias: PropTypes.func.isRequired,
    taxesInformationRequest: PropTypes.func,
    immTaxesInformation: PropTypes.object,
    immPartialAmortization: PropTypes.object.isRequired,
    requestPlanAmortization: PropTypes.func,
    requestPartialAmortization: PropTypes.func,
    history: PropTypes.object.isRequired,
};

LoanView.defaultProps = {
    params: {}
}

module.exports = withRouter(connect(
    state => ({
        immLoans: state.loans,
        immAccounts: state.accounts,
        immMortgageAssociatedInsurances: state.mortgageAssociatedInsurances,
        immTaxesInformation: state.mortgageRequestTaxesInformation,
        immProfile: state.profile,
        immPartialAmortization: state.loanPartialAmortization,
        immFlagBasedFeatures: state.flagBasedFeatures,
    }), {
    getCollectiveInfo: collectiveActions.getCollectiveInfo,
    getMortgageAssociatedInsurances,
    requestPublicInformation,
    requestLoanGeneralData,
    requestLoanInterveners,
    postAlias: loansAliasActions.setLoanAlias,
    taxesInformationRequest: mortgageRequestTaxesInformationActions.taxesInformationRequest,
    requestPlanAmortization: partialAmortizationAction.requestPlanAmortization,
    requestPartialAmortization: partialAmortizationAction.requestPartialAmortization
}
)(LoanView));
